import { useIntl } from "react-intl";

import { accountsCss, avatarsCss, entryCss, entryFooterCss, titleCss, updatedAtCss } from "./index.styles";

import { ContributorsTextLabel } from "~/client/components/ContributorsTextLabel";
import { FormattedRelativeTimeWithAutoUnit } from "~/client/components/FormattedRelativeTimeWithAutoUnit";
import type { NoteAndCommentItem } from "~/client/components/search/hooks/useNoteAndCommentSearchResult";
import { EntryIcon } from "~/client/components/search/SearchBoxDropdown/EntryIcon";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { UserAvatarsWithOverflowIcon } from "~/client/components/UserAvatarsWithOverflowIcon";

const renderContributors = ({ account }) => <span>{account}</span>;
const renderOtherContributors = ({ count }) => <span>{count}</span>;

interface Props {
  item: NoteAndCommentItem;
  isSelected: boolean;
}
export const NoteAndComment: React.FC<Props> = ({ item, isSelected }) => {
  const intl = useIntl();

  return (
    <ListItem isSelected={isSelected}>
      <ListItemLink to={item.path}>
        <div css={entryCss}>
          <EntryIcon typename={item.document.__typename} />
          <div>
            <div dangerouslySetInnerHTML={{ __html: item.titleHtml }} css={titleCss} />
            <div css={entryFooterCss}>
              <div css={avatarsCss}>
                <UserAvatarsWithOverflowIcon users={item.contributors} size="xsmall" isLink={false} isPopup={false} />
              </div>
              <div css={accountsCss}>
                <ContributorsTextLabel
                  intl={intl}
                  contributors={item.contributors}
                  renderIndividual={renderContributors}
                  renderOther={renderOtherContributors}
                />
              </div>
              <div css={updatedAtCss}>
                <FormattedRelativeTimeWithAutoUnit value={Date.parse(item.contentUpdatedAt)} />
              </div>
            </div>
          </div>
        </div>
      </ListItemLink>
    </ListItem>
  );
};
